// Utility functions for Club Challenges

export const formatCurrency = (value) => {
  if (!value || value === "--") return value;
  
  // If it's already a string with commas, return as is
  if (typeof value === "string" && value.includes(",")) {
    return value;
  }
  
  // Convert to number and format with commas
  const numValue = typeof value === "string" ? parseFloat(value.replace(/,/g, "")) : value;
  return numValue.toLocaleString();
};

export const getStatusColor = (status) => {
  switch (status) {
    case "live":
      return "#4CAF50";
    case "upcoming":
      return "#FF9800";
    case "open":
      return "#2196F3";
    case "completed":
      return "#9E9E9E";
    default:
      return "#757575";
  }
};

export const getStatusLabel = (status) => {
  return status.charAt(0).toUpperCase() + status.slice(1);
};

export const sortTableData = (data, sortBy, sortDirection) => {
  if (!data) return data;
  
  return [...data].sort((a, b) => {
    let aValue = a[sortBy];
    let bValue = b[sortBy];
    
    // Handle special cases
    if (sortBy === "date") {
      aValue = new Date(aValue);
      bValue = new Date(bValue);
    } else if (sortBy === "totalUsers" || sortBy === "totalEntries" || sortBy === "prizePool" || sortBy === "profit") {
      aValue = aValue === "--" ? 0 : parseFloat(aValue.replace(/,/g, ""));
      bValue = bValue === "--" ? 0 : parseFloat(bValue.replace(/,/g, ""));
    } else if (sortBy === "margin") {
      aValue = parseFloat(aValue.replace("%", ""));
      bValue = parseFloat(bValue.replace("%", ""));
    }
    
    if (sortDirection === "asc") {
      return aValue > bValue ? 1 : -1;
    } else {
      return aValue < bValue ? 1 : -1;
    }
  });
}; 